import { auth } from "@/services";
import { newsPolicy } from "@/policies";

(function (angular) {
  "use strict";

  angular.module("app").service("News", news);

  news.$inject = ["$q", "modalService"];

  function news($q, modalService) {
    /**
     * Opens a modal allowing a user to manage a news item
     *
     * @param {number?} newsId Will create a new news article if falsy
     * @return {{ result: Promise<any> }}
     */
    function manageNews(newsId) {
      const deferred = $q.defer();

      if (!newsId) {
        if (!newsPolicy.canCreate(auth.user())) {
          deferred.reject("Create news; permission denied.");
          return { result: deferred.promise };
        }
      }

      modalService
        .open({
          templateUrl: "modals/manage-news.html",
          controller: "manageNewsController",
          windowClass: "manage-news",
          resolve: {
            newsId: () => newsId,
          },
        })
        .result.then(deferred.resolve)
        .catch(deferred.reject);

      return { result: deferred.promise };
    }

    return {
      manageNews,
    };
  }
})(angular);
